import { ErrorHandler, inject, Injectable } from '@angular/core';
import { VersionCheckService } from './version-check.service';

@Injectable()
export class ChunkErrorHandler extends ErrorHandler {
	private readonly versionCheckService = inject(VersionCheckService);

	override handleError(error: unknown): void {
		super.handleError(error);

		if (!this.isChunkLoadError(error)) {
			return;
		}

		this.versionCheckService.notifyChunkLoadFailure();
	}

	private isChunkLoadError(error: unknown): boolean {
		const message = error instanceof Error ? error.message : String(error);
		const name = error instanceof Error ? error.name : '';
		const normalizedMessage = message.toLowerCase();

		return (
			name === 'ChunkLoadError' ||
			normalizedMessage.includes('chunkloaderror') ||
			normalizedMessage.includes('loading chunk') ||
			normalizedMessage.includes('failed to fetch dynamically imported module') ||
			normalizedMessage.includes('error loading dynamically imported module') ||
			normalizedMessage.includes('importing a module script failed')
		);
	}
}
